<template>
  <card type="user">
    <p class="header">
      Admin Info
    </p>
    <div class="author">

      <a href="#">
        <el-avatar
          style="vertical-align:middle;width:90px;height:90px;"
          fit="fill">
          <img
            :src="user.city_admin.city.logo_url"
            loading="lazy"
            title="用户图片"
            alt="用户图片"
          >
        </el-avatar>
        <h5 class="title">{{ user.city_admin.city.business_name }}</h5>
      </a>
      <p class="description">
        {{ user.city_admin.city.contact_name }}
      </p>
    </div>
    <p/>

    <!--just add it here to make the style work-->
    <div class="ql-snow">
      <div class="ql-editor">
        <div v-html="user.city_admin.city.description"/>
      </div>
    </div>
    <div
      slot="footer"
      class="button-container">
      <base-button
        v-if="user.city_admin.city.facebook"
        icon
        round>
        <a
          :href="user.city_admin.city.facebook"
          target="_blank">
          <i class="fab fa-facebook"/>
        </a>
      </base-button>
      <base-button
        v-if="user.city_admin.city.twitter"
        icon
        round>
        <a
          :href="user.city_admin.city.twitter"
          target="_blank">
          <i class="fab fa-twitter"/>
        </a>
      </base-button>
      <base-button
        v-if="user.city_admin.city.instagram"
        icon
        round>
        <a
          :href="user.city_admin.city.instagram"
          target="_blank">
          <i class="fab fa-instagram"/>
        </a>
      </base-button>
      <base-button
        v-if="user.city_admin.city.youtube"
        icon
        round>
        <a
          :href="user.city_admin.city.youtube"
          target="_blank">
          <i class="fab fa-youtube"/>
        </a>
      </base-button>
    </div>
  </card>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['user'])
  }
}
</script>
<style>
</style>
